<template>
  <div class="forums">
    <div
      class="forum-select upper"
      :class="{ hovered: upperHovered, unhovered: lowerHovered }"
      @mouseenter="mouseEnterUpper"
      @mouseleave="mouseLeave"
      @click="clickUpper"
    >
      <div class="inner upper" :style="upperStyle">
        <label>Er du til igler i buksen...</label>
      </div>
    </div>
    <div
      class="forum-select lower"
      :class="{ hovered: lowerHovered, unhovered: upperHovered }"
      @mouseenter="mouseEnterLower"
      @mouseleave="mouseLeave"
      @click="clickLower"
    >
      <div class="inner lower" :style="lowerStyle">
        <label>... eller bacon i blodet?</label>
      </div>
    </div>
  </div>
</template>

<script>
import leechImage from "../assets/leechbg.png";
import dkImage from "../assets/dkbg.png";

export default {
  data() {
    return {
      upperHovered: false,
      lowerHovered: false,
    };
  },
  computed: {
    upperStyle() {
      return {
        backgroundImage: 'url("' + leechImage + '")',
        backgroundColor: "#d05366",
        backgroundSize: "120px",
      };
    },
    lowerStyle() {
      return {
        backgroundImage: 'url("' + dkImage + '")',
        backgroundColor: "#444444",
        backgroundSize: "120px",
      };
    },
  },
  methods: {
    mouseEnterUpper() {
      this.upperHovered = true;
    },
    mouseEnterLower() {
      this.lowerHovered = true;
    },
    mouseLeave() {
      this.upperHovered = false;
      this.lowerHovered = false;
    },
    clickUpper() {
      this.$router.push("/igler");
    },
    clickLower() {
      this.$router.push("/igler");
    },
  },
};
</script>

<style lang="scss" scoped>
.forums {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  .forum-select {
    width: 100%;
    height: calc(50% - 2px);
    opacity: 0.8;

    transition: height 0.2s, opacity 0.2s;
    cursor: pointer;

    &.upper {
      padding: 0 0 2px;
    }

    &.lower {
      padding: 2px 0 0;
    }

    .inner {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      &.upper {
        background-color: grey;
      }

      &.lower {
        background-color: grey;
      }

      label {
        font-size: 70px;
        font-style: italic;
        font-weight: 300;
        cursor: inherit;
        text-shadow: 1px 1px 5px #ffffff;
        font-weight: 600;

        transition: font-size 0.2s;
      }
    }

    &.hovered {
      height: calc(60% - 2px);
      opacity: 1;

      label {
        font-size: 80px;
      }
    }

    &.unhovered {
      height: calc(40% - 2px);
    }
  }
}

@media only screen and (max-width: 1000px) {
  .forums {
    .forum-select {
      &.hovered {
        .inner {
          label {
            font-size: 70px !important;
          }
        }
      }
      .inner {
        label {
          font-size: 60px;
        }
      }
    }
  }
}

@media only screen and (max-width: 800px) {
  .forums {
    .forum-select {
      &.hovered {
        .inner {
          label {
            font-size: 50px !important;
          }
        }
      }
      .inner {
        label {
          font-size: 40px;
        }
      }
    }
  }
}

@media only screen and (max-width: 600px) {
  .forums {
    .forum-select {
      &.hovered {
        .inner {
          label {
            font-size: 40px !important;
          }
        }
      }
      .inner {
        label {
          font-size: 30px;
        }
      }
    }
  }
}

@media only screen and (max-width: 400px) {
  .forums {
    .forum-select {
      width: calc(100% - 10px);
      height: calc(50% - 7px);

      &.upper {
        padding: 5px 5px 2px !important;
      }

      &.lower {
        padding: 2px 5px 5px !important;
      }

      &.hovered {
        .inner {
          label {
            font-size: 30px !important;
          }
        }
      }

      .inner {
        label {
          font-size: 25px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
